import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MultipleTestCasesContext, TestCasesLoaderContext } from "../MultiTestCaseGenerationPage";
import MultipleEvaluationSummary from "../../output-components/testcase-generation/MultipleEvaluationSummary";
import MultipleUserStoriesComponent from "../../output-components/testcase-generation/MultipleUserStoriesComponent";
import MultipleRefinedUserStory from "../../output-components/testcase-generation/MutilpleRefinedUserStory";
import { Box, Typography } from "@mui/material";
import MultipleTestCases from "../../output-components/testcase-generation/MultipleTestCases";
import MultipleUseCase from "../../output-components/testcase-generation/MultipleUseCaseComponent";
import { ReactComponent as AutomateIcon } from "../../../images/automateIcon.svg";
import FullscreenToggle from "../../custom-components/FullScreenToggle";
import FunctionalSpecDocument from "../../output-components/testcase-generation/FunctionalSpecificationDocument";
import TestCasesComponent from "../../output-components/testcase-generation/TestCasesComponent";
import TestConditionsComponent from "../../output-components/testcase-generation/TestConditions";
import MultipleTestConditionsComponent from "../../output-components/testcase-generation/MultipleTestConditions";
import MultipleTestTechniquesComponent from "../../output-components/testcase-generation/MultipleTestTechniques";
import SelectedTestingTypesComponent from "../../output-components/testcase-generation/SelectedTestingTypesComponent";

const MultipleTestCasesOutputPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    multipleUserStories,
    setMultipleUserStories,
    selectedUserStories,
    setSelectedUserStories,
    functionalSpecDocument,
    setFunctionalSpecDocument,
    multipleUseCases,
    setMultipleUseCases,
    selectedUseCases,
    setSelectedUseCases,
    testConditions,
    setTestConditions,
    testingTechniques,
    setTestingTechniques,
    traceabilityMatrix,
    setTraceabilityMatrix,
    multiTestCases,
    setMultiTestCases,
    selectedMultipleTestCases,
    setSelectedMultipleTestCases,
    selectedTestingTypes,
    setSelectedTestingTypes,
  } = useContext(MultipleTestCasesContext);

  useEffect(() => {
    if (!location.state?.userStories) {
      return navigate("/dashboard/generate-testcases/input");
    }
    if (!location.state.userStories.length) {
      return navigate("/dashboard/generate-testcases/input");
    }

    setMultipleUserStories(location.state?.userStories || []);
    setSelectedUserStories(location.state?.selectedUserStories || []);
    setFunctionalSpecDocument(location.state?.functionalSpecDocument || {});
    setMultipleUseCases(location.state?.multipleUseCases || []);
    setSelectedUseCases(location.state?.selectedMultipleUseCases || []);
    setTestConditions(location.state?.testConditions || []);
    setTestingTechniques(location.state?.testingTechniques || {});
    setTraceabilityMatrix(location.state?.traceabilityMatrix || {});
    setMultiTestCases(location.state?.multipleTestCases || []);
    setSelectedMultipleTestCases(location.state?.selectedMultipleTestCases || []);
    setSelectedTestingTypes(location.state?.selectedTestingTypes || []);
  }, [
    location.state?.userStories,
    location.state?.selectedUserStories,
    location.state?.functionalSpecDocument,
    location.state?.multipleUseCases,
    location.state?.selectedMultipleUseCases,
    location.state?.testConditions,
    location.state?.testingTechniques,
    location.state?.traceabilityMatrix, ,
    location.state?.multipleTestCases,
    location.state?.selectedMultipleTestCases,
    location.state?.selectedTestingTypes,
  ]);

  return (

    <Box
      sx={{
        display: "flex",
        bgcolor: "#f6f3f2",
        minHeight: "80vh",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        //overflowY: "scroll",
        width: "100%",
        height: "70vh",
        position: "relative",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "thin",
        "&::-webkit-scrollbar": {
          width: "8px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888",
          borderRadius: "4px",
          minHeight: "20px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#555",
        },
      }}
    >
      <Box>
        <Box
          sx={{
            width: { xs: '100%', md: 966, lg: 1100 },
            margin: "10px auto",
            "& > *:not(:last-child)": {
              marginBottom: "16px", // Adds margin between components but not after the last one
            },
            //height: "100%",
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            position={"sticky"}
          // top={0}
          >

            <Box display="flex">
              <AutomateIcon style={{ marginRight: 10 }} />
              {/* Informative text */}
              <Typography
                variant="body2"
                color="text.secondary"
                gutterBottom
                sx={{ mt: 0.5, }}
                fontSize={"12px"}
              >
                Automate and create comprehensive, high-quality test cases
                effortlessly
              </Typography>
            </Box>
            {/* <FullscreenIcon sx={{width: "24px"}}/> */}
            <FullscreenToggle />
          </Box>

          {!!multipleUserStories.length && <MultipleUserStoriesComponent />}
          {!!Object.entries(functionalSpecDocument).length && <FunctionalSpecDocument />}
          {!!multipleUseCases.length && <MultipleUseCase />}
          {!!testConditions.length && <MultipleTestConditionsComponent testConditionsData={testConditions} setTestConditionsData={setTestConditions} />}
          {!!Object.entries(testingTechniques).length && <MultipleTestTechniquesComponent />}
          <SelectedTestingTypesComponent />
          {!!Object.entries(traceabilityMatrix).length && <TestCasesComponent testCasesData={multiTestCases} setTestCasesData={setMultiTestCases} traceabilityMatrix={traceabilityMatrix} />}

          <Box
            component="footer"
            sx={{
              width: { xs: '100%', md: 966, lg: 1100 },
              backgroundColor: "#f6f3f2",
              textAlign: "center",
              paddingX: "5px",
              position: "fixed",
              bottom: "0",
              zIndex: "99"
            }}
          >
            <Typography variant="caption" color="textSecondary">
              Use QMentisAI™ with human supervision, as with all generative AI tools.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MultipleTestCasesOutputPage;
